module.exports = __webpack_public_path__ + "img/noBookmarkedProfiles.c9092f49.svg";